// extracted by mini-css-extract-plugin
export default {"message":"_2U7P6","countdown":"JPnIG","countdown-value":"_3nVLn","countdownValue":"_3nVLn","countdown-ended":"_2KNgw","countdownEnded":"_2KNgw"};